import styled from 'styled-components'

export const AutocompleteWrapper = styled.div`
	width: ${props => props.$width || '100%'};
`

export const InputActions = styled.div`
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	gap: 8px;
	z-index: 2;
`

export const ClearButton = styled.button.attrs({ type: 'button' })`
	background: none;
	border: none;
	padding: 2px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0.6;
	transition: opacity 0.2s;
	&:hover {
		opacity: 1;
	}
`

export const ChevronButton = styled.div`
	display: flex;
	align-items: center;
	color: ${props => props.theme.colors.text.secondaryText};
	transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'none'};
	transition: transform 0.2s ease;
	cursor: ${props => props.$disabled ? 'default' : 'pointer'};
	svg {
		width: 12px;
		height: 12px;
	}
`
